module.exports = __webpack_public_path__ + "img/img-18.c70c7eb9.png";